
import { useState } from 'react';

const ServicesPage = () => {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      title: "Executive Security",
      description: "Comprehensive protection services for high-profile individuals, corporate executives, and government officials.",
      features: [
        "24/7 Personal Protection",
        "Threat Assessment & Analysis",
        "Secure Transportation",
        "Residential Security",
        "Event Security Planning",
        "Emergency Response Protocols"
      ],
      image: "https://public.readdy.ai/ai/img_res/e1e510e1b340a5f515fb449e334ba802.jpg"
    },
    {
      title: "Tactical Training",
      description: "Advanced operational training for small units, law enforcement, and security personnel.",
      features: [
        "Small Unit Tactics",
        "Urban Combat Training",
        "Marksmanship Programs",
        "Close Quarters Combat",
        "Team Coordination",
        "Mission Planning"
      ],
      image: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20outdoor%20tactical%20training%20with%20silhouetted%20instructors%20barely%20visible%20in%20shadows%2C%20training%20personnel%20as%20faint%20silhouettes%2C%20completely%20plain%20tactical%20uniforms%20with%20no%20visible%20text%20or%20patches%2C%20anonymous%20military%20contractors%20in%20deep%20shadows%2C%20very%20dark%20moody%20lighting%2C%20professional%20training%20silhouettes%2C%20barely%20visible%20figures%20in%20tactical%20formation&width=600&height=400&seq=tactical-training-dark-silhouettes&orientation=landscape"
    },
    {
      title: "Combat Medicine (TCCC)",
      description: "Tactical Combat Casualty Care training and advanced medical response protocols.",
      features: [
        "Tactical Field Medicine",
        "Trauma Response",
        "Medical Equipment Training",
        "Evacuation Procedures",
        "Life-Saving Techniques",
        "Combat Medic Certification"
      ],
      image: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20outdoor%20combat%20medical%20training%20with%20silhouetted%20medics%20barely%20visible%20in%20shadows%2C%20tactical%20medical%20personnel%20as%20faint%20silhouettes%2C%20completely%20plain%20uniforms%20with%20no%20visible%20text%20or%20patches%2C%20anonymous%20medical%20team%20in%20deep%20shadows%2C%20very%20dark%20moody%20lighting%2C%20professional%20medical%20training%20silhouettes%2C%20barely%20visible%20figures%20with%20medical%20equipment&width=600&height=400&seq=combat-medicine-dark-silhouettes&orientation=landscape"
    },
    {
      title: "Reconnaissance & Tracking",
      description: "Advanced surveillance, tracking, and intelligence gathering operations.",
      features: [
        "Combat Tracking",
        "Surveillance Operations",
        "Intelligence Gathering",
        "Reconnaissance Planning",
        "Stealth Techniques",
        "Target Identification"
      ],
      image: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20outdoor%20reconnaissance%20operations%20with%20silhouetted%20surveillance%20team%20barely%20visible%20in%20shadows%2C%20reconnaissance%20personnel%20as%20faint%20silhouettes%2C%20completely%20plain%20tactical%20clothing%20with%20no%20visible%20text%20or%20patches%2C%20anonymous%20operators%20in%20deep%20shadows%2C%20very%20dark%20moody%20lighting%2C%20professional%20surveillance%20silhouettes%2C%20barely%20visible%20figures%20conducting%20stealth%20operations&width=600&height=400&seq=reconnaissance-dark-silhouettes&orientation=landscape"
    },
    {
      title: "NVG Operations",
      description: "Night Vision Goggle employment and low-light tactical operations training.",
      features: [
        "Night Vision Training",
        "Low-Light Operations",
        "Equipment Proficiency",
        "Tactical Movement",
        "Target Acquisition",
        "Night Combat Tactics"
      ],
      image: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20outdoor%20night%20vision%20training%20with%20silhouetted%20operators%20barely%20visible%20in%20shadows%2C%20NVG%20personnel%20as%20faint%20silhouettes%2C%20completely%20plain%20tactical%20uniforms%20with%20no%20visible%20text%20or%20patches%2C%20anonymous%20team%20in%20deep%20shadows%2C%20very%20dark%20moody%20lighting%2C%20professional%20night%20operations%20silhouettes%2C%20barely%20visible%20figures%20with%20night%20vision%20equipment&width=600&height=400&seq=nvg-operations-dark-silhouettes&orientation=landscape"
    },
    {
      title: "Force Protection",
      description: "Comprehensive security risk management and antiterrorism services.",
      features: [
        "Risk Assessment",
        "Threat Mitigation",
        "Perimeter Security",
        "Access Control",
        "Emergency Response",
        "Antiterrorism Measures"
      ],
      image: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20outdoor%20force%20protection%20operations%20with%20silhouetted%20security%20team%20barely%20visible%20in%20shadows%2C%20protection%20personnel%20as%20faint%20silhouettes%2C%20completely%20plain%20tactical%20uniforms%20with%20no%20visible%20text%20or%20patches%2C%20anonymous%20security%20operators%20in%20deep%20shadows%2C%20very%20dark%20moody%20lighting%2C%20professional%20security%20silhouettes%2C%20barely%20visible%20figures%20in%20defensive%20positions&width=600&height=400&seq=force-protection-dark-silhouettes&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white pt-16">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">
            Security <span className="text-yellow-500">Services</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Comprehensive tactical training and executive protection services delivered by elite government security contractors
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Service Navigation */}
            <div className="lg:col-span-1">
              <div className="sticky top-24">
                <h3 className="text-2xl font-bold mb-6 text-white">Our Services</h3>
                <div className="space-y-2">
                  {services.map((service, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveService(index)}
                      className={`w-full text-left p-4 rounded-lg transition-all duration-300 cursor-pointer ${
                        activeService === index
                          ? 'bg-yellow-500 text-black font-bold'
                          : 'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50'
                      }`}
                    >
                      {service.title}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Service Details */}
            <div className="lg:col-span-2">
              <div className="bg-gray-800/30 backdrop-blur-sm border border-gray-700 rounded-xl p-8">
                <div className="mb-8">
                  <img
                    src={services[activeService].image}
                    alt={services[activeService].title}
                    className="w-full h-64 object-cover rounded-lg mb-6"
                  />
                  <h2 className="text-3xl font-bold mb-4 text-white">
                    {services[activeService].title}
                  </h2>
                  <p className="text-lg text-gray-400 leading-relaxed mb-8">
                    {services[activeService].description}
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-4 text-yellow-500">Key Features</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {services[activeService].features.map((feature, index) => (
                      <div key={index} className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
                        <span className="text-gray-300">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-700">
                  <button className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
                    Request Service Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 via-black to-gray-900">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6 text-white">
            Need Custom <span className="text-yellow-500">Security Solutions?</span>
          </h2>
          <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto">
            Contact our team for tailored security services and training programs designed for your specific requirements.
          </p>
          <button className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
            Schedule Consultation
          </button>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
